import Cookies from "universal-cookie";
const cookies = new Cookies();

export const isLocalEnvironment = () => {
  let localEnv = false;
  const env = window.location.hostname.toLowerCase();
  localEnv = env === "localhost";
  return localEnv;
};

export const getPruRequestCounter = () => {
  let wcfRequestCounter = 0;

  const setCounter = (intCounter: number) => {
    intCounter = ++intCounter;
    const stringCounter = intCounter.toString();
    sessionStorage.setItem("wcfRequestCounter", stringCounter);
  };

  if (sessionStorage.getItem("wcfRequestCounter")) {
    const reqCounter = sessionStorage.getItem("wcfRequestCounter");
    const intCounter = reqCounter ? parseInt(reqCounter) : 0;
    wcfRequestCounter = intCounter;
    setCounter(intCounter);
  } else if (cookies.get("wcfRequestCounter")) {
    wcfRequestCounter = cookies.get("wcfRequestCounter");
    cookies.set("wcfRequestCounter", ++wcfRequestCounter);
  } else {
    setCounter(0);
  }
  return wcfRequestCounter;
};

export const getPruRequestID = () => {
  const requestURI = (document.cookie.match(/JSESSIONID=[^;]+/) || [""])[0];
  const index = requestURI.indexOf("=");
  let requestId = index >= 0 ? requestURI.substring(index + 1) : "";
  const chars =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

  for (let i = 10; i > 0; --i)
    requestId += chars[Math.round(Math.random() * (chars.length - 1))];

  return "wcf_" + requestId;
};
export const currencyFormatter = (value: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0
  }).format(Math.round(value));